import { makeStyles } from '@material-ui/styles';

export const useStyle = makeStyles(function() {
  return {
    card: {
      background: '#FFFFFF',
      borderRadius: '16px',
      padding: '0',
      width: '100%',
      maxWidth: '420px',
      boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.25)',
      overflow: 'hidden',
    },
    cardHeader: {
      background: 'linear-gradient(135deg, #007a60 0%, #009677 60%, #50b848 100%)',
      padding: '28px 36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100px',
      '& img': {
        height: '70px',
        display: 'block',
        margin: '0 auto',
      },
      '& h2': {
        fontFamily: 'Lato',
        fontWeight: '700',
        fontSize: '16px',
        color: '#FFFFFF',
        margin: '0',
        lineHeight: '24px',
        opacity: '0.9',
      },
    },
    testBanner: {
      background: 'red',
      color: '#FFFFFF',
      fontFamily: 'Open Sans',
      fontWeight: '600',
      fontSize: '12px',
      textAlign: 'center',
      padding: '8px',
      margin: '0',
    },
    cardBody: {
      padding: '32px 36px 28px',
    },
    input: {
      background: '#F7F7F7',
      borderRadius: '8px',
      width: '100%',
      fontFamily: 'Open Sans',
      fontSize: '14px',
      marginBottom: '16px',
    },
    loginforms: {
      marginBottom: '8px',
      width: '100%',
    },
    forgotPassword: {
      textAlign: 'right',
      marginBottom: '24px',
      '& span': {
        fontFamily: 'Open Sans',
        fontSize: '13px',
        color: '#009677',
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    },
    loginBtn: {
      width: '100%',
      height: '48px',
      background: '#009677',
      borderRadius: '8px',
      color: '#FFFFFF',
      fontFamily: 'Open Sans',
      fontWeight: '700',
      fontSize: '15px',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        background: '#007a60',
      },
    },
    errorText: {
      color: 'red',
      fontFamily: 'Open Sans',
      fontSize: '12px',
      margin: '0 0 8px 0',
    },
    languageRow: {
      marginBottom: '20px',
    },
  };
});
